import React, { useState, useEffect } from "react";
import ReactDatePicker from 'react-datepicker';
import "react-datepicker/dist/react-datepicker.css";

const CustomDatePicker = ({ 
    dateFormat = "dd MMM yyyy", 
    resetDate, 
    onDateChange, 
    setResetDate,
    selected // Add selected prop to handle external date values
}) => {
    const [selectedDate, setSelectedDate] = useState(selected || null);

    useEffect(() => {
        if (resetDate) {
            setSelectedDate(null);
            setResetDate(false);
        }
    }, [resetDate, setResetDate]);

    // Sync with external selected value changes
    useEffect(() => {
        setSelectedDate(selected || null);
    }, [selected]);

    const handleDateChange = (date) => {
        setSelectedDate(date);
        onDateChange(date);
    };

    return (
        <ReactDatePicker
            className='form-control'
            selected={selectedDate}
            onChange={handleDateChange}
            dateFormat={dateFormat}
            placeholderText="Select date"
            showYearDropdown
            scrollableYearDropdown
            yearDropdownItemNumber={15}
            dropdownMode="select"
            peekNextMonth
            showMonthDropdown
            useShortMonthInDropdown
        />
    );
};

export default CustomDatePicker;